export default {
      id: "teamwork-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#teamwork",
      toString: function () {
        return this.url;
      }
    }